import { useState, useEffect } from "react";
import "./Filter.css";

const Filter = ({
  categories,
  onFilterSubmit,
  selectedCategory: propSelectedCategory,
  searchTerm: propSearchTerm,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  // predchozi zvolene kategorie (pokud uz by zvoleny)
  useEffect(() => {
    if (propSearchTerm !== undefined) {
      setSearchTerm(propSearchTerm);
    }
    if (propSelectedCategory !== undefined) {
      setSelectedCategory(propSelectedCategory);
    }
  }, [propSearchTerm, propSelectedCategory]);

  const handleFilterSubmit = () => {
    onFilterSubmit({ searchTerm, selectedCategory });
  };

  return (
    <div className="d-flex flex-column align-items-center w-100 pt-5 pb-5">
      <h2 className="pb-3">Filtr vyhledávání</h2>
      <div className="filter col-10 d-flex flex-column flex-md-row align-items-center justify-content-center">
        <div className="filter-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
          </svg>
          <input
            className=""
            placeholder="hledat.."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          ></input>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x-lg ms-2"
            viewBox="0 0 16 16"
            onClick={() => setSearchTerm("")}
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        </div>
        <div className="filter-categories">
          <svg
            fill="#000000"
            className="bi-filter"
            width="26px"
            height="26px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <title>bars-filter</title>{" "}
              <path d="M30 6.749h-28c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h28c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM24 14.75h-16c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h16c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM19 22.75h-6.053c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h6.053c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0z"></path>{" "}
            </g>
          </svg>
          <div className="dropdown">
            <button
              className="dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedCategory === "" ? "Kategorie" : selectedCategory}
            </button>
            <ul className="dropdown-menu">
              {categories.map((category) => (
                <li key={category.id}>
                  <span
                    className="dropdown-item"
                    onClick={() => setSelectedCategory(category.category)}
                  >
                    {category.category}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x-lg ms-2"
            viewBox="0 0 16 16"
            onClick={() => setSelectedCategory("")}
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        </div>
        <button
          className="filter-btn"
          onClick={() => {
            handleFilterSubmit();
          }}
        >
          Filtrovat
        </button>
      </div>
    </div>
  );
};
export default Filter;
